import React from 'react'
import styled from 'styled-components'
import { Layer } from '~/packages/general/variable/spaceTime.types'
import { StyleForLayer } from './styleForLayer.util'
import { attributionMarginLeftPx } from '~/components/map/map'
import LayerLegend from './layerLegend.component'
import LegendsInfo from './legendsInfo.component'

const Wrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  bottom: calc(${attributionMarginLeftPx}px + 0.3rem);
  left: 0;

  display: flex;
  flex-direction: column;

  padding: 1rem;

  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadow(1)};

  background-color: white;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: ${({ theme }) => theme.backdropBackground};
    -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
    backdrop-filter: ${({ theme }) => theme.backdropFilter};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    display: none;
  }

  h2 {
    font-size: 0.7rem;
    font-weight: 700;
    margin: 0;
    margin-bottom: 0.3rem;
    text-transform: uppercase;
  }

  .legends {
    display: flex;
    flex-direction: row;
  }
`

const Separator = styled.div`
  width: 1px;
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  margin: 0 1rem;
`

const TextDivider = styled.p`
  text-align: center;
  font-size: 0.8rem;
  font-weight: normal;
  margin: 0;
  color: #7d7d7d;
`

interface LegendsContainerProps {
  layers: Layer[]
  styles: StyleForLayer[]
  isInMenu?: boolean
  title?: string
  additionalInformation?: () => JSX.Element
}

export default function LegendsContainer({
  layers,
  styles,
  isInMenu = false,
  additionalInformation,
  title,
}: LegendsContainerProps) {
  const WrapperLegend = isInMenu ? 'div' : Wrapper

  return (
    <WrapperLegend className={isInMenu ? 'legends-wrapper' : ''}>
      {isInMenu ? (
        <>
          <hr />
          <TextDivider>Legenda{layers.length > 1 ? 's' : ''}</TextDivider>
        </>
      ) : (
        <>
          <h2>Legenda{layers.length > 1 ? 's' : ''}</h2>
          {additionalInformation && title && (
            <LegendsInfo title={title} information={additionalInformation} />
          )}
        </>
      )}
      <div className='legends'>
        {layers.map((layer, index) => {
          const style = styles[index]
          return (
            <React.Fragment key={`legend-${index}`}>
              {index > 0 && <Separator />}
              <LayerLegend width={isInMenu ? '100%' : 'revert-layer'} layer={layer} style={style} />
            </React.Fragment>
          )
        })}
      </div>
    </WrapperLegend>
  )
}
